<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12VnzjU/tc-custom/9781488066047.jpg?1721429381051" alt="This image is the cover for the book One Snowy Night with Lord Hauxton"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Snowy Night with Lord Hauxton
      </h1>
      <p class="bookDescription body article font2">
        <b>A runaway debutante finds herself secluded and snowed in with a broodingly handsome earl in this Regency romance.</b><br/><br/>To escape the judgment of her overbearing mother, Henrietta Harvey flees London for a friend’s estate in the Kentish countryside. Though she withstands the harsh winter weather on her journey, she will never live down the mortification of accidentally slipping into bed with Lord Hauxton!<br/><br/>The fellow guest is in no way amused by the pretty young lady’s honest mistake. But when they find themselves snowed in together the following morning, Henrietta discovers that this cold man has an intriguingly warmer side. Still, hiding a secret that would shock the ton, she’s resigned to becoming a spinster. Unless she can trust him with the truth, before the snow melts . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29a4fd46